import { CallAPI } from "../utils/api";
import { getSessionToken } from "../utils/api";

export function AddDocument( {date, title, description, file, onProgress}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const form = new FormData();
    form.append("file", file);
    form.append("date", date);
    form.append("title", title);
    form.append("description", description);

    xhr.open("POST", `${process.env.REACT_APP_API_URL}/addDocument`);

    const session = getSessionToken();
    xhr.setRequestHeader("Authorization", `Bearer ${session}`);

    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable) return;
      const percent = Math.round((event.loaded * 100) / event.total);
      onProgress?.(percent);
    };

    xhr.onload = () => {
      try {
        const res = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(res);
        } else {
          reject(res);
        }
      } catch {
        reject({ error: "Invalid server response" });
      }
    };

    xhr.onerror = () => {
      reject({ error: "Network error" });
    };

    xhr.send(form);
  });
}


export async function GetDocuments(date) {
  return CallAPI(
    `/getDocuments/${date}`,
    {
      method: "GET",
    },
    true
  );
}

export async function GetDocumentThumbUrl(docID) {
  const token = getSessionToken(); 
  const res = await fetch(`${process.env.REACT_APP_API_URL}/documents/${docID}/thumb`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) return null;
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}

export async function FetchDocumentObjectUrl(docID) {
  const token = getSessionToken();

  const res = await fetch(`${process.env.REACT_APP_API_URL}/documents/${docID}/download`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    let err = {};
    try { err = await res.json(); } catch {}
    throw err?.error ? err : { error: "خطا در دریافت فایل" };
  }

  const blob = await res.blob();

  // نام فایل از هدر (اگر هست)
  const cd = res.headers.get("content-disposition") || "";
  const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
  const filenameFromHeader = match ? decodeURIComponent(match[1]) : null;

  const url = URL.createObjectURL(blob);
  return { url, blob, filename: filenameFromHeader };
}

export function SaveBlobAs(blob, filename = "document") {
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}

// export async function UpdateDocumentStage(id, field, date) {
//   const data = {
//     field: field,
//     date: date,
//   };  
//   return CallAPI(
//     `/updateDocumentStage/${id}`,
//     {
//       method: "PATCH",
//       body: JSON.stringify(data),
//     },
//     true
//   );
// }

// export async function DeleteDocument(id) {
//   return CallAPI(
//     `/deleteDocument/${id}`,
//     {
//       method: "DELETE",
//     },
//     true
//   );
// }


// export async function EditDocument(id, payload) {
//   return CallAPI(
//     `/editDocument/${id}`,
//     {
//       method: "PATCH",
//       body: JSON.stringify(payload),
//     },
//     true
//   );
// }

